// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"modal-header__modal-header___34yh4"};